<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="apn">
        <el-select v-model="queryParams.state" filterable placeholder="APN" @change="search" clearable multiple >
          <el-option value="Gloabl" label="Gloabl"></el-option>
          <el-option value="mobile.three.com.hk" label="mobile.three.com.hk"></el-option>
          <el-option value="smartone" label="smartone"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="userId">
        <el-cascader
          placeholder="公司名"
          ref="myCascader"
          :options="agentTree"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false,multiple: true }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.userIds"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID/ICCIDS空格隔开"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item prop="imei">
        <el-input v-model="queryParams.imei" placeholder="请输入IMEI"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item prop="eid">
        <el-input v-model="queryParams.eid" placeholder="请输入EID"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item prop="deviceSn">
        <el-input v-model="queryParams.deviceSn" placeholder="设备号"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>

      <el-form-item  prop="state">
        <el-select v-model="queryParams.state" filterable placeholder="状态" @change="search" clearable multiple >
          <el-option value="Released" label="Released"></el-option>
          <el-option value="Enable" label="Enable"></el-option>
          <el-option value="Delete" label="Delete"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-download"  v-hasPermi="['card:export']">导出</el-button>
        <el-button type="primary" icon="el-icon-first-aid-kit" v-hasPermi="['card:renewal']">套餐续费</el-button>
      </el-form-item>
    </el-form>
      <el-table 
        :data="tableData" 
        border
        id="out-table"
        ref="tableData"
        v-loading="loading"
      >
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="company" label="代理商" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="deviceSn" label="设备型号" align="center" width="100px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="imei" label="IMEI" align="center" width="160px"></el-table-column>
      <el-table-column prop="basicIccid" label="种子卡" align="center" width="220px">
        <template slot-scope="{ row }">
          <!-- 显示种子卡信息 -->
          <span>{{ row.basicIccid }}</span>
          <!-- 切换图标，点击触发 showDialog 方法 -->
          <svg-icon icon-class="switch" style="font-size:18px;margin-left:6px" @click="showDialog(row)"/>
          <!-- <el-icon @click="showDialog(row)" class="switch-icon"></el-icon> -->
        </template>
      </el-table-column>
      <el-table-column prop="iccid" label="使用卡" align="center" width="220px">
        <template slot-scope="{ row }">
          <!-- 显示种子卡信息 -->
          <span>{{ row.iccid }}</span>
          <!-- 切换图标，点击触发 showDialog 方法 -->
          <svg-icon icon-class="switch" style="font-size:18px;margin-left:6px" @click="showDialogCard(row)"/>
          <!-- <el-icon @click="showDialog(row)" class="switch-icon"></el-icon> -->
        </template>
      </el-table-column>
      <el-table-column prop="eid" label="EID" align="center" width="100px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="installDevice" label="安装设备" align="center" width="200px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="installCount" label="安装次数" align="center" width="100px"></el-table-column>
      <el-table-column prop="installTime" label="安装时间" align="center" width="200px" ></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center" width="200px" ></el-table-column>
      <el-table-column prop="state" label="状态" align="center" width="120px" v-if="adminShow">
        <template slot-scope="{row}">
          <el-tag v-if="row.state =='Enable'">Enable</el-tag>
          <el-tag v-else-if="row.state =='Released'" type="info">Released</el-tag>
          <el-tag v-else-if="row.state =='Delete'" type="error">Delete</el-tag>
          <el-tag v-else type="warning">未知</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary" plain
              icon="el-icon-view"
              v-hasPermi="['card:esim:qrcode']"
            >详情</el-button>
          <el-button
            size="mini"
            type="primary" plain
            icon="el-icon-refresh"
            @click="refresh(scope.row)"
            v-hasPermi="['card:esim:refresh']"
          >刷新</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />

    <el-dialog title="更换种子卡" :visible.sync="showQrCode" :lock-scroll="false" width="500px" v-dialogDrag center>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="原种子卡">
          <el-input v-model="form.basicIccid"></el-input>
        </el-form-item>
        <el-form-item label="新种子卡">
          <el-input v-model="form.iccid"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="showQrCode = true">立即切换</el-button>
          <el-button @click="showQrCode = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="更换使用卡" :visible.sync="show" :lock-scroll="false" width="500px" v-dialogDrag center>
      <el-form ref="form" :model="formData" label-width="80px">
        <el-form-item label="原卡">
          <el-input v-model="formData.iccid"></el-input>
        </el-form-item>
        <el-form-item label="新卡">
          <el-input v-model="formData.newIccid"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="show = true">立即切换</el-button>
          <el-button @click="show = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
      <!-- 弹出框组件 -->
    
  </div>
</template>
<script>

import { cardEsimPage , eSIMQrCode , eSIMRefresh} from "@/api/esim.js";
import { agentTreeList } from "@/api/api.js"; //代理商
export default {
  name: "internationalCards",
  data() {
    return {
        total:0,
        page:1,
        pageSize:20,
        // 代理商
        agentTree: [],
        tableData:[],
        queryParams:{
            key:'VSIM',
            userId:undefined,
            iccid:undefined,
            state:undefined,
            userIds:[],
            eid:undefined
        },
        showQrCode:false,
        scanQrCode:'',
        form:{
          basicIccid:'',
          iccid:''
        },
        formData:{
          iccid:''
        },
        show:false

    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    //代理商列表
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    showDialog(row){
      this.showQrCode = true;
      this.form.basicIccid = row.basicIccid;
    },
    showDialogCard(row){
      this.show = true;
      this.formData.iccid = row.iccid;
    },
    initData(){
      this.loading = true;
      let params = {
          model:{
              ... this.queryParams
          },
          page: this.page,
          pageSize: this.pageSize,
      };
      cardEsimPage(params).then(res => {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
      });
    },
    search() {
      this.page = 1,
      this.initData();
    },
    resetQuery() {
      this.resetForm("queryForm");
      this.$refs.myCascader.$refs.panel.clearCheckedNodes();
      this.$refs.myCascader.$refs.panel.activePath = [];
      this.search();
    },
    info(row) {
      this.$router.push({path:"/international/internationalDetail",query:{iccid: row.iccid}});
    },
    //复制数据
    copy(data) {
      let url = data;
      let oInput = document.createElement('input');
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
          message: '复制成功',
          type: 'success',
          duration:1000
      });
      oInput.remove()
    },
    handleEsimQrcode(row){
      this.showQrCode = true
      let iccid = row.iccid
      eSIMQrCode({iccid}).then(res=>{
        this.scanQrCode = "data:image/jpeg;base64," + res.data.data;
      })
    },
    refresh(row){
      let iccid = row.iccid
      eSIMRefresh({iccid}).then(res=>{
        this.initData()
        this.$message.success("刷新成功");
      })
    }
  },
  created() {
    this.initData()
    this.handleAgentTreeList();
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
.qrcode-image{
  text-align: center;
  .el-image {
    width: 300px;
    height: 300px;
  }
}
.switch-icon {
  margin-left: 10px; // 图标与种子卡信息的间距
  cursor: pointer; // 鼠标悬停显示手型
  color: #409EFF; // 图标颜色
  font-size: 18px; // 图标大小
}
</style>
